import { render, staticRenderFns } from "./DocumentsSearchFilter.vue?vue&type=template&id=fc126136&scoped=true&"
import script from "./DocumentsSearchFilter.vue?vue&type=script&lang=ts&"
export * from "./DocumentsSearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsSearchFilter.vue?vue&type=style&index=0&id=fc126136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc126136",
  null
  
)

export default component.exports